import { Star, ExternalLink } from "lucide-react";

// Verified Google reviews, copied word-for-word (shortened with "…") from
// Zwahili's public Google listing on 14 Oct 2026. Rating 4.5 from 167 reviews.
export const GOOGLE_REVIEWS_URL =
  "https://search.google.com/local/reviews?placeid=ChIJL1-N9E1klR4RxBvQU_GuZMU";
const RATING = 4.5;
const COUNT = 167;

const reviews = [
  {
    author: "AJ Forsythe",
    rating: 5,
    text: "One of the best lodge experiences we’ve had in South Africa. From the moment we arrived, the staff made us feel like family — warm, attentive, and always one step ahead.",
  },
  {
    author: "Dallas Wolford",
    rating: 5,
    text: "We stayed in the Presidential Suite, which was absolutely exquisite, and the meals, service, and attention to detail throughout our stay were exceptional.",
  },
  {
    author: "Walter Graham",
    rating: 5,
    text: "Me and my wife booked the Wildly Romantic Bushbreak here which we thoroughly enjoyed!! … The executive suite we stayed in is stunning and spacious!",
  },
];

const Stars = ({ n, size = 14 }: { n: number; size?: number }) => (
  <div className="flex gap-0.5 text-gold" aria-label={`${n} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={size} fill={i < Math.round(n) ? "currentColor" : "none"} strokeWidth={i < Math.round(n) ? 0 : 1.5} aria-hidden="true" />
    ))}
  </div>
);

const GoogleReviews = () => (
  <section aria-labelledby="google-reviews-title" className="border border-border rounded-sm p-6 sm:p-10 mt-12 bg-card">
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-gold font-medium mb-2">Verified Google Reviews</p>
        <h2 id="google-reviews-title" className="font-heading text-2xl md:text-3xl">What our guests say</h2>
      </div>
      <div className="flex items-center gap-3">
        <span className="font-heading text-3xl">{RATING}</span>
        <div>
          <Stars n={RATING} size={16} />
          <p className="text-xs text-muted-foreground mt-1">{COUNT} Google reviews</p>
        </div>
      </div>
    </div>
    <ul className="grid gap-6 md:grid-cols-3">
      {reviews.map((r) => (
        <li key={r.author} className="border-l-2 border-accent pl-5">
          <Stars n={r.rating} />
          <blockquote className="font-heading italic text-sm sm:text-base leading-relaxed mt-3">“{r.text}”</blockquote>
          <p className="mt-3 text-[11px] tracking-[0.2em] uppercase text-muted-foreground">{r.author} · Google</p>
        </li>
      ))}
    </ul>
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 mt-8 text-xs tracking-[0.2em] uppercase text-gold hover:text-gold-dark transition-colors"
    >
      Read all reviews on Google <ExternalLink size={14} />
    </a>
  </section>
);

export default GoogleReviews;
